import React, { useEffect, useState } from "react";
import { AnalyticsPageStyle } from "./Analytics.styled";
import TopBar from "../../components/TopBar/TopBar";
import { MainBodyStyle } from "../../styles/MainBodyStyles";
import { HeadingStyle } from "../../styles/HeadingStyles";
import Footer from "../../components/footer/Footer";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import TotalNoCard from "../../components/TotalNoCard/TotalNoCard";
import ImpressionCharts from "../../components/ImpressionCharts/ImpressionCharts";
import NoDataChart2 from "../../components/NoDataChart/NoDataChart2";

const Analytics = () => {
  const { state } = useLocation();
  const { analyticsData } = state || {}; // Destructure the analytics data passed from the previous screen
  const [totalServedCount, setTotalServedCount] = useState(0);
  const [totalEngagedCount, setTotalEngagedCount] = useState(0);
  const [selectedPlacement, setSelectedPlacement] = useState(null);
  const [chartData, setChartData] = useState({ served: 0, engaged: 0 });

  // If analyticsData is not available, show an error
  useEffect(() => {
    if (!analyticsData) {
      toast.error("No analytics data found");
      return;
    }

    const data = analyticsData.sponsorAnalytics || [];    // Calculate total served and engaged counts from the analytics data
    const servedCount = data.reduce((acc, item) => acc + item.servedCount, 0);
    const engagedCount = data.reduce((acc, item) => acc + item.engagedCount, 0);    setTotalServedCount(servedCount);
    setTotalEngagedCount(engagedCount);
    
    // Set initial chart data to show totals
    setChartData({ served: servedCount, engaged: engagedCount });
  }, [analyticsData]);

  // Function to handle card click and update chart data
  const handleCardClick = (placement = null) => {
    if (placement) {
      setSelectedPlacement(placement);
      setChartData({ served: placement.servedCount, engaged: placement.engagedCount });
    } else {
      // Show totals when "All" card is clicked
      setSelectedPlacement(null);
      setChartData({ served: totalServedCount, engaged: totalEngagedCount });
    }
  };

  return (
    <AnalyticsPageStyle>
      <TopBar authorized={true} />
      <MainBodyStyle>
        <HeadingStyle>Sponsor Analytics</HeadingStyle>

        <div className="main-content">
          {/* Cards Section */}
          <div className="card-container">            {/* "All" Card with Total Counts */}
            <TotalNoCard
              heading={"All"}
              total={
                <>
                  Total Served Count: {totalServedCount}
                  <br />
                  Total Engaged Count: {totalEngagedCount}
                </>
              }
              onClick={() => handleCardClick()}
              isSelected={selectedPlacement === null}
            />            {/* Loop through each placement type to show individual placement cards */}
            {analyticsData && analyticsData.sponsorAnalytics && analyticsData.sponsorAnalytics.map((item) => (
              <TotalNoCard
                key={item.sponsorPlacementId}
                heading={item.placementType}
                total={
                  <>
                    Served Count: {item.servedCount}
                    <br />
                    Engaged Count: {item.engagedCount}
                  </>
                }
                onClick={() => handleCardClick(item)}
                isSelected={selectedPlacement && selectedPlacement.sponsorPlacementId === item.sponsorPlacementId}
              />
            ))}
          </div>          {/* Donut Chart */}
          <div>
            {chartData.served !== 0 || chartData.engaged !== 0 ? (
              <ImpressionCharts
                datasetIdKey={"Impression"}
                module="Impressions"
                data={{ confirmed: chartData.engaged, unConfirmed: chartData.served }}
              />
            ) : (
              <NoDataChart2 datasetIdKey={"012@"} module="Impressions" />
            )}
          </div>
        </div>
      </MainBodyStyle>
      <Footer style="footer" />
    </AnalyticsPageStyle>
  );
};

export default Analytics;
